@if (data?.nodes.length > 0) {
  <mat-label
    class="bold section-subtitle mat-typography"
    >{{ title || data?.title }}</mat-label
    >
  }
  <mat-tree
    class="grey-background"
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    >
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button disabled></button>
      <span class="node-name">
        {{ node?.name }}
      </span>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <button
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name"
        >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <span class="node-name">
        {{ node?.name }}
      </span>
    </mat-tree-node>
  </mat-tree>
